import React from 'react'
import { createRoot } from 'react-dom/client'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import './index.css'
import { GTM_ID } from 'config'
import 'tw-elements'
import 'react-toastify/dist/ReactToastify.css'
import 'react-loading-skeleton/dist/skeleton.css'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

// Analytics
import { hotjarKeys, metaPixelInit, moengageInit } from 'analytics/init'
import { hotjar } from 'react-hotjar'
import ReactGA from 'react-ga'
import mixpanel from 'mixpanel-browser'
import TagManager from 'react-gtm-module'

// Sentry
import * as Sentry from '@sentry/react'

import App from './App'

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn:
      process.env.NODE_ENV !== 'development'
        ? process.env.REACT_APP_SENTRY_DSN
        : process.env.REACT_APP_SENTRY_TEST_FRONT_WALLET_DNS,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  })
}

const tagManagerArgs = {
  gtmId: GTM_ID
}

TagManager.initialize(tagManagerArgs)
moengageInit()
mixpanel.init(process.env.REACT_APP_MIXPANEL)
ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS)
metaPixelInit()
hotjar.initialize(hotjarKeys['es-AR'], 6)

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <React.StrictMode>
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY}
      language='es'
    >
      <App />
    </GoogleReCaptchaProvider>
  </React.StrictMode>
)
